import React from "react";
import { SiteLayout } from "@/components/layout/SiteLayout";
import { PageHero } from "@/components/layout/PageHero";
import { CtaBand } from "@/components/layout/CtaBand";
import { Section, SectionHeading } from "@/components/layout/Section";
import { Reveal } from "@/components/common/Reveal";
import { Quality } from "@/components/sections/Quality";
import { Confidentiality } from "@/components/sections/Confidentiality";
import { METHOD } from "@/content/pagesContent";

export default function Metodo() {
  return (
    <SiteLayout>
      <PageHero
        testId="metodo-page"
        micro={METHOD.microLabel}
        title={METHOD.title}
        description={METHOD.description}
      />

      <Section id="method-principles-section" tone="offwhite">
        <Reveal>
          <SectionHeading
            microLabel="PRINCIPI"
            title="Quattro principi, un solo standard."
          />
        </Reveal>
        <div className="mt-12 grid grid-cols-1 gap-6 sm:grid-cols-2">
          {METHOD.principles.map((p, i) => (
            <Reveal key={p.title} delay={i * 0.05}>
              <div className="flex h-full gap-5 rounded-2xl border border-strato-gray-100 bg-strato-white p-6">
                <span className="strato-micro mt-1 text-strato-blue">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <div>
                  <h3 className="font-display text-lg font-medium text-strato-graphite">
                    {p.title}
                  </h3>
                  <p className="mt-2 text-sm leading-[1.6] text-muted-foreground">
                    {p.description}
                  </p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </Section>

      <Quality />
      <Confidentiality />

      <CtaBand />
    </SiteLayout>
  );
}
